import ApplicationAdapter from 'garaje/adapters/application';
import config from 'garaje/config/environment';
import urlBuilder from 'garaje/utils/url-builder';

interface EventLogQuery {
  companyId?: number;
  [key: string]: unknown;
}

export default class EventLogAdapter extends ApplicationAdapter {
  host = config.apiOverwrittenHost;
  namespace = 'a/event-logs/api/v1';

  get headers(): Record<string, string> {
    return {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    };
  }

  urlForQuery(query: EventLogQuery): string {
    const companyId = query.companyId;
    if (!companyId) {
      throw new Error('companyId is required for event-log queries');
    }
    delete query.companyId; // remove from query params since it's in the URL
    return urlBuilder.eventLogs.search(companyId);
  }
}
